import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { OutsideClick } from 'wanderu-hocs';

import styles from './OffCanvasMenu.scss';

function OffCanvasMenu(props) {
    const {
        isOpen = false,
        onCloseMenu = () => undefined,
        children,
        globalBannerVisible = false,
    } = props;

    function _onCloseMenu(e) {
        if (!isOpen) {
            return;
        }

        _preventGhostClick(e);
        onCloseMenu();
    }

    function _preventGhostClick(e) {
        e.preventDefault();
    }

    return (
        <div>
            {isOpen && <div className={styles.deemphasize} />}
            <div
                className={classNames(
                    styles.container,
                    {
                        [styles.opened]: isOpen,
                        [styles.globalBannerVisible]: globalBannerVisible,
                    },
                )}
            >
                {isOpen && (
                    <OutsideClick
                        className={styles.menu}
                        onOutsideClick={_onCloseMenu}
                    >
                        <div>{children}</div>
                    </OutsideClick>
                )}
            </div>
        </div>
    );
}

OffCanvasMenu.propTypes = {
    children: PropTypes.node,
    globalBannerVisible: PropTypes.bool,
    isOpen: PropTypes.bool,
    onCloseMenu: PropTypes.func,
};

export default OffCanvasMenu;
